export const stateData = {
  "Alabama":        { sun: 136, utility: 0.135, inflation: 0.028, installCostPerWatt: 2.85, incentiveRate: 0.02, netMeteringFactor: 0.82 },
  "Arizona":        { sun: 163, utility: 0.122, inflation: 0.027, installCostPerWatt: 2.50, incentiveRate: 0.05, netMeteringFactor: 0.90 },
  "California":     { sun: 150, utility: 0.231, inflation: 0.034, installCostPerWatt: 3.30, incentiveRate: 0.07, netMeteringFactor: 0.98 },
  "Colorado":       { sun: 145, utility: 0.138, inflation: 0.030, installCostPerWatt: 2.90, incentiveRate: 0.05, netMeteringFactor: 0.92 },
  "Connecticut":    { sun: 116, utility: 0.225, inflation: 0.032, installCostPerWatt: 3.20, incentiveRate: 0.06, netMeteringFactor: 0.96 },
  "Florida":        { sun: 142, utility: 0.127, inflation: 0.028, installCostPerWatt: 2.95, incentiveRate: 0.03, netMeteringFactor: 0.85 },
  "Georgia":        { sun: 137, utility: 0.123, inflation: 0.026, installCostPerWatt: 2.80, incentiveRate: 0.03, netMeteringFactor: 0.88 },
  "Hawaii":         { sun: 155, utility: 0.341, inflation: 0.045, installCostPerWatt: 3.90, incentiveRate: 0.10, netMeteringFactor: 1.00 },
  "Idaho":          { sun: 138, utility: 0.103, inflation: 0.022, installCostPerWatt: 2.50, incentiveRate: 0.04, netMeteringFactor: 0.91 },
  "Illinois":       { sun: 118, utility: 0.131, inflation: 0.028, installCostPerWatt: 2.80, incentiveRate: 0.05, netMeteringFactor: 0.93 },
  "Massachusetts":  { sun: 115, utility: 0.228, inflation: 0.032, installCostPerWatt: 3.00, incentiveRate: 0.06, netMeteringFactor: 0.96 },
  "Michigan":       { sun: 112, utility: 0.170, inflation: 0.029, installCostPerWatt: 2.75, incentiveRate: 0.03, netMeteringFactor: 0.87 },
  "Minnesota":      { sun: 120, utility: 0.140, inflation: 0.030, installCostPerWatt: 2.80, incentiveRate: 0.04, netMeteringFactor: 0.92 },
  "Nevada":         { sun: 157, utility: 0.115, inflation: 0.028, installCostPerWatt: 2.65, incentiveRate: 0.05, netMeteringFactor: 0.95 },
  "New Jersey":     { sun: 116, utility: 0.178, inflation: 0.033, installCostPerWatt: 3.10, incentiveRate: 0.07, netMeteringFactor: 0.98 },
  "New Mexico":     { sun: 160, utility: 0.128, inflation: 0.027, installCostPerWatt: 2.60, incentiveRate: 0.04, netMeteringFactor: 0.88 },
  "New York":       { sun: 118, utility: 0.204, inflation: 0.035, installCostPerWatt: 3.20, incentiveRate: 0.06, netMeteringFactor: 0.97 },
  "North Carolina": { sun: 133, utility: 0.121, inflation: 0.029, installCostPerWatt: 2.85, incentiveRate: 0.04, netMeteringFactor: 0.89 },
  "Ohio":           { sun: 115, utility: 0.135, inflation: 0.027, installCostPerWatt: 2.65, incentiveRate: 0.03, netMeteringFactor: 0.86 },
  "Oregon":         { sun: 124, utility: 0.118, inflation: 0.030, installCostPerWatt: 2.95, incentiveRate: 0.04, netMeteringFactor: 0.94 },
  "Pennsylvania":   { sun: 114, utility: 0.151, inflation: 0.029, installCostPerWatt: 2.75, incentiveRate: 0.03, netMeteringFactor: 0.90 },
  "South Carolina": { sun: 137, utility: 0.131, inflation: 0.028, installCostPerWatt: 2.80, incentiveRate: 0.03, netMeteringFactor: 0.87 },
  "Tennessee":      { sun: 130, utility: 0.115, inflation: 0.026, installCostPerWatt: 2.70, incentiveRate: 0.03, netMeteringFactor: 0.85 },
  "Texas":          { sun: 146, utility: 0.135, inflation: 0.032, installCostPerWatt: 2.70, incentiveRate: 0.04, netMeteringFactor: 0.88 },
  "Utah":           { sun: 150, utility: 0.110, inflation: 0.029, installCostPerWatt: 2.80, incentiveRate: 0.04, netMeteringFactor: 0.90 },
  "Virginia":       { sun: 130, utility: 0.130, inflation: 0.028, installCostPerWatt: 2.85, incentiveRate: 0.04, netMeteringFactor: 0.89 },
  "Washington":     { sun: 110, utility: 0.107, inflation: 0.031, installCostPerWatt: 3.00, incentiveRate: 0.05, netMeteringFactor: 0.94 },
  "Wisconsin":      { sun: 115, utility: 0.170, inflation: 0.030, installCostPerWatt: 2.80, incentiveRate: 0.03, netMeteringFactor: 0.88 },
};

export const panelTypes = [
  { id: "mono",     label: "Monocrystalline", defaultWatt: 400, watt: 400 },
  { id: "poly",     label: "Polycrystalline",  defaultWatt: 370, watt: 370 },
  { id: "thin",     label: "Thin Film",         defaultWatt: 340, watt: 340 },
  { id: "bifacial", label: "Bifacial",          defaultWatt: 430, watt: 430 },
];

export const roofTypes = [
  { id: "asphalt", label: "Asphalt shingle", sub: "Most common" },
  { id: "tile",    label: "Tile / Slate",    sub: "Mediterranean" },
  { id: "metal",   label: "Metal roof",      sub: "Ideal for solar" },
  { id: "flat",    label: "Flat roof",       sub: "Commercial style" },
];

export const financeOpts = [
  { id: "cash",  label: "Cash purchase", sub: "Best long-term ROI" },
  { id: "loan",  label: "Solar loan",    sub: "$0 down, own system" },
  { id: "lease", label: "Lease / PPA",   sub: "Low upfront cost" },
];

export const shadingOpts = [
  { id: "none",     label: "No shading",    sub: "Full sun", factor: 1.00 },
  { id: "light",    label: "Light shading", sub: "< 20%",    factor: 0.90 },
  { id: "moderate", label: "Moderate",      sub: "20–40%",   factor: 0.75 },
  { id: "heavy",    label: "Heavy shading", sub: "> 40%",    factor: 0.60 },
];

export const dirOpts = [
  { id: "south", label: "South", sub: "Best",        factor: 1.00 },
  { id: "east",  label: "East",  sub: "",             factor: 0.85 },
  { id: "west",  label: "West",  sub: "",             factor: 0.85 },
  { id: "north", label: "North", sub: "Least ideal",  factor: 0.65 },
];

export const creditOpts = [
  { id: "excellent", label: "720+",    sub: "Excellent" },
  { id: "good",      label: "680–719", sub: "Good" },
  { id: "fair",      label: "620–679", sub: "Fair" },
  { id: "low",       label: "< 620",   sub: "May need cosigner" },
];

export const PANEL_AREA_SQFT = 21;
export const ITC_RATE        = 0.30;
export const BATTERY_COST_PER_KWH = 420;